import React, { useState } from "react";
// const FAQItem = ({ faq }) => {
//   const [isOpen, setIsOpen] = useState(false);

//   const toggle = () => setIsOpen(!isOpen);

//   return (
//     <div style={{ marginBottom: "15px" }}>
//       <div
//         style={{
//           cursor: "pointer",
//           fontWeight: "600",
//           display: "flex",
//           justifyContent: "space-between",
//         }}
//         onClick={toggle}
//       >
//         {faq.question} <span>{isOpen ? "−" : "+"}</span>
//       </div>

//       {isOpen && (
//         <div style={{ paddingLeft: "15px", marginTop: "5px" }}>
//           <p>{faq.answer}</p>
//           {faq.images && faq.images.length > 0 && (
//             <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
//               {faq.images.map((img, i) => (
//                 <img
//                   key={i}
//                   src={img}
//                   alt={`FAQ step ${i + 1}`}
//                   style={{ width: "100%", height: "auto", borderRadius: "8px" }}
//                 />
//               ))}
//             </div>
//           )}

//           {/* Render sub-questions recursively */}
//           {faq.subQuestions &&
//             faq.subQuestions.map((sub, idx) => (
//               <FAQItem key={idx} faq={sub} />
//             ))}
//         </div>
//       )}
//     </div>
//   );
// };

// const FAQItem = ({ faq, level = 0 }) => {
//   const [activeIndex, setActiveIndex] = useState(null);

//   const toggleSub = (index) => {
//     setActiveIndex(activeIndex === index ? null : index);
//   };

//   return (
//     <div style={{ marginLeft: level * 15 + "px", marginBottom: "10px" }}>
//       <div
//         style={{
//           cursor: "pointer",
//           fontWeight: level === 0 ? 600 : 500,
//           display: "flex",
//           justifyContent: "space-between",
//         }}
//         onClick={() => toggleSub(0)} // for main question, treat as index 0
//       >
//         {faq.question} <span>{activeIndex === 0 ? "−" : "+"}</span>
//       </div>

//       {activeIndex === 0 && (
//         <div style={{ paddingLeft: "10px", marginTop: "5px" }}>
//           <p>{faq.answer}</p>
//           {faq.images && faq.images.length > 0 && (
//             <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
//               {faq.images.map((img, i) => (
//                 <img
//                   key={i}
//                   src={img}
//                   alt={`FAQ step ${i + 1}`}
//                   style={{ width: "120px", borderRadius: "8px" }}
//                 />
//               ))}
//             </div>
//           )}

//           {faq.subQuestions &&
//             faq.subQuestions.map((sub, idx) => (
//               <FAQItem key={idx} faq={sub} level={level + 1} />
//             ))}
//         </div>
//       )}
//     </div>
//   );
// };

const FAQItem = ({ faq, level = 0 }) => {
  const [activeSubIndex, setActiveSubIndex] = useState(null);

  const toggleSub = (index) => {
    setActiveSubIndex(activeSubIndex === index ? null : index);
  };

  return (
    <div style={{ marginLeft: level * 20 + "px", marginTop: "10px" }}>
      {/* Main answer & content */}
      <p style={{ margin: "5px 0" }}>{faq.answer}</p>

      {/* Images */}
      {faq.images && faq.images.length > 0 && (
        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
          {faq.images.map((img, i) => (
            <img
              key={i}
              src={img}
              alt={`FAQ step ${i + 1}`}
              style={{ width: "100%", height: "auto", borderRadius: "8px" }}
            />
          ))}
        </div>
      )}

      {/* Sub-questions */}
      {faq.subQuestions && faq.subQuestions.length > 0 && (
        <div style={{ marginTop: "10px" }}>
          {faq.subQuestions.map((sub, idx) => (
            <div key={idx}>
              <div
                style={{
                  cursor: "pointer",
                  fontWeight: 500,
                  display: "flex",
                  justifyContent: "space-between",
                }}
                onClick={() => toggleSub(idx)}
              >
                {sub.question}
                <span>{activeSubIndex === idx ? "−" : "+"}</span>
              </div>

              {activeSubIndex === idx && (
                <FAQItem faq={sub} level={level + 1} />
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FAQItem;